import { FC } from "react";
import {
    Grid,
    GridItem,
    Box,
    Heading,
    Picture,
    Text,
} from "@smile2impress/components/relaunch";

import { HalfTextAndImageBannerProps } from "./HalfTextAndImageBanner.types";

export const HalfTextAndImageBanner: FC<HalfTextAndImageBannerProps> = ({
    content,
    headingAs,
}) => {
    const { title, subtitle, image } = content;

    return (
        <Grid
            gridTemplateColumns={["1fr", "1fr", "1fr 1fr"]}
            columnGap={[0, 0, 5.5]}
            alignItems={["stretch", "stretch", "start"]}
            mt={[3, 3, 0]}
        >
            {image && (
                <GridItem
                    gridColumn={["auto", "auto", 2]}
                    gridRow={["auto", "auto", 1]}
                    px={[2, 2, 0]}
                    mb={[3, 3, 0]}
                >
                    <Box borderRadius="sm" overflow="hidden" h={[8, 8, 10]}>
                        <Picture {...image} h="100%" fit="cover" />
                    </Box>
                </GridItem>
            )}
            <GridItem
                gridColumn={["auto", "auto", 1]}
                gridRow={["auto", "auto", 1]}
                px={[2, 2, 0]}
            >
                <Heading as={headingAs} textStyle="H2" color="text.primary">
                    {title}
                </Heading>
                {!!subtitle && (
                    <Text textStyle="title3" color="text.base" mt={1}>
                        {subtitle}
                    </Text>
                )}
            </GridItem>
        </Grid>
    );
};
